module.exports = __webpack_public_path__ + "static/media/access-second@3x.d5c2c8df.jpg";